import "./index.scss";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import { Button } from "components/UI/atoms";
import { useNavigate } from "hooks/useCustomNavigation";

export const OrderOffer = ({
  denomination,
  old_price,
  new_price,
  savings,
  brand_name,
  brand_logo_url,
  redemption_url
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => navigate(redemption_url);

  const values = [denomination, old_price, new_price, savings];
  [denomination, old_price, new_price, savings] = values.map(
    toMoneyWithTwoDecimalDigits
  );

  return (
    <div className="order-offer" data-testid="order-offer">
      <div className="offer-content">
        <img src={brand_logo_url} alt="logo" className="mobile-logo" />
        <div className="details">
          <h3>24 hours only</h3>
          <h1>Special Deal!</h1>
          <img src={brand_logo_url} alt="logo" className="tablet-logo" />
          <p className="name">{brand_name}</p>
          <p>
            Buy a {denomination} gift card for <s>{old_price}</s>{" "}
            <span className="new-price">{new_price}</span>
          </p>
        </div>
      </div>
      <Button customClassName="save-button" onClick={handleButtonClick}>
        Buy now and Save {savings}!
      </Button>
    </div>
  );
};
